import { useState, useMemo, useEffect } from "react";

import { Svg_LogoTipo } from "../../components/Svg";

import { Btn, Input_Password, Input_Text } from "../../components/Input";

import { SetStatusGlobal } from "../../interface/Global";

import { CheckPassword } from "../../services/Function";

import Axios from 'axios';

import Env from "../../services/Env";

import './Login.css';

interface LoginResponse {
    status: boolean;
    name?: string;
    file?: string;
    token?: string;
    error?: string | '';
}

export default function Page_Login() {

    const [ code, setCode ]               = useState<string>('');
    const [ email, setEmail ]             = useState<string>('');
    const [ password, setPassword ]       = useState<string>('');
    const [ password2, setPassword2 ]     = useState<string>('');
    const [ msgError, setMsgError ]       = useState<string>('');
    const [ statusError, setStatusError ] = useState<boolean>(false);
    const [ stage, setStage ]             = useState<number>(0);
    
    const passwordCheck = useMemo(() => CheckPassword(password, password2), [password, password2]);

    async function LoginDash(event: React.FormEvent<HTMLFormElement>){
        event.preventDefault();
        try {
            const response = await Axios.post<LoginResponse>(Env.apiUrl, {
                type_page: 'login',
                email,
                password
            });
            
            if(response.data.status){
                const userName = response.data.name ?? '';
                const userFile = "/assets/users/" + (response.data.file ?? '');

                localStorage.setItem('user_name', userName);
                localStorage.setItem('user_file', userFile);
                localStorage.setItem('token', response.data.token ?? '');

                SetStatusGlobal('user_name', userName);
                SetStatusGlobal('user_file', userFile);
                SetStatusGlobal('dashboard', true);
            }else {
                setMsgError(response.data.error ?? '');
                SetStatusGlobal('dashboard', false);
                setStatusError(true);
            }
            
        }catch (error){
            setStatusError(true);
        }
    }   

    async function CheckData(data: { type: string, email?: string, code?: string, password?: string }){
        SetStatusGlobal('loading', true);

        try {
            const response = await Axios.post<LoginResponse>(Env.apiUrl, {
                type_page: data.type,
                email: data.email,
                code: data.code,
                password: data.password
            });
            
            SetStatusGlobal('loading', false);

            if(!response.data.status){
                setStatusError(true);
            }else {
                setStatusError(false);
                if(data.type === 'check_email'){
                    setStage(2);
                }else if(data.type === 'check_code'){
                    setStage(3);
                }else if(data.type === 'alt_password'){
                    setStage(4);
                }
            }
            
        }catch (error){
            setStatusError(true);
        }
    }

    function PositionStage(){
        switch (stage) {
            case 1:
                return (
                    <div className="div_position_stage">
                        <div className="position_stage">
                            <div className="position active_btn">1</div>
                            <div className="line" />
                            <div className="position">2</div>
                            <div className="line" />
                            <div className="position">3</div>
                            <div className="line" />
                            <div className="position">4</div>
                        </div>

                        <div className="inf_login">
                            <div className="title">Access recovery</div>
                            <div className="subtitle">Please enter your email below</div>
                        </div>

                        <div className="div_inputs">
                            <div className="input">
                                <Input_Text title="Email" type="email" value={ email } setValue={ setEmail } placeholder="Enter your email" required={ true } />
                            </div>
                        </div>
                        
                        {
                            statusError ?
                                <div className="subtitle return_error">
                                    Email not found. Please check if you typed it correctly or try another email address.
                                </div>
                            : null
                        }

                        <div className="btn_">
                            <Btn title="Verify Email" type="div" OpenFuncition={ ()=>{ CheckData({ type: 'check_email', email }) } } />
                        </div>

                        <div className="subtitle return_login">
                            <div className="" onClick={ () => { setStage(0); setStatusError(false); } }>
                                Return login? <span onClick={ () => { setStage(0); setStatusError(false); } }>Click here</span>
                            </div>
                        </div>
                    </div>
                );

            case 2:
                return (
                    <div className="div_position_stage">
                        <div className="position_stage">
                            <div className="position active_btn">1</div>
                            <div className="line active_line" />
                            <div className="position active_btn">2</div>
                            <div className="line active_line" />
                            <div className="position">3</div>
                            <div className="line" />
                            <div className="position">4</div>
                        </div>

                        <div className="inf_login">
                            <div className="title">Access recovery</div>
                            <div className="subtitle">Please enter your code below</div>
                        </div>

                        <div className="div_inputs">
                            <div className="input">
                                <Input_Text title="Code" value={ code } setValue={ setCode } placeholder="Enter your code" required={ true } />
                            </div>
                        </div>
                            
                        {
                            statusError ?
                                <div className="subtitle return_error">
                                    Code not found. Please check if you typed it correctly or try another code.
                                </div>
                            : null
                        }

                        <div className="btn_">
                            <Btn title="Verify Code" type="div" OpenFuncition={ ()=>{ CheckData({ type: 'check_code', email, code }) } } />
                        </div>

                        <div className="subtitle return_login">
                            <div className="" onClick={ () => { setStage(0); setStatusError(false); } }>
                                Return login? <span onClick={ () => { setStage(0); setStatusError(false); } }>Click here</span>
                            </div>
                        </div>
                    </div>
                );

            case 3:
                return (
                    <div className="div_position_stage">
                        <div className="position_stage">
                            <div className="position active_btn">1</div>
                            <div className="line active_line" />
                            <div className="position active_btn">2</div>
                            <div className="line active_line" />
                            <div className="position active_btn">3</div>
                            <div className="line" />
                            <div className="position">4</div>
                        </div>

                        <div className="inf_login">
                            <div className="title">Access recovery</div>
                            <div className="subtitle">Please enter your new password below</div>
                        </div>

                        <div className="div_inputs div_">
                            <div className="input">
                                <Input_Password title="Password" value={ password } setValue={ setPassword } placeholder="Enter your new password" required={ true } setStage={ setStage } />
                            </div>
                        </div>

                        <div className="div_inputs div_">
                            <div className="input">
                                <Input_Password title="Confirm Password" value={ password2 } setValue={ setPassword2 } placeholder="Confirm your new password" required={ true } setStage={ setStage } />
                            </div>
                        </div>

                        <div className="subtitle">
                            <div className={ passwordCheck.minLength ? "yes_save" : "not_save" }>The password must be at least 6 characters long.</div>
                            <div className={ passwordCheck.special   ? "yes_save" : "not_save" }>The password must contain special characters.</div>
                            <div className={ passwordCheck.hasNumber ? "yes_save" : "not_save" }>The password must contain at least 1 number.</div>
                            <div className={ passwordCheck.hasUpper  ? "yes_save" : "not_save" }>The password must contain at least 1 uppercase letter.</div>
                            <div className={ passwordCheck.match     ? "yes_save" : "not_save" }>The passwords must match.</div>
                        </div>

                        <div className="btn_">
                            <Btn title="Change Password" type="div" OpenFuncition={ Object.values(passwordCheck).every(Boolean) ? ()=>{ CheckData({ type: 'alt_password', email, code, password }) } : undefined } />
                        </div>

                        <div className="subtitle return_login">
                            <div className="" onClick={ () => { setStage(0); setStatusError(false); } }>
                                Return login? <span onClick={ () => { setStage(0); setStatusError(false); } }>Click here</span>
                            </div>
                        </div>
                    </div>
                );

            case 4:
                return (
                    <div className="div_position_stage">
                        <div className="position_stage">
                            <div className="position active_btn">1</div>
                            <div className="line active_line" />
                            <div className="position active_btn">2</div>
                            <div className="line active_line" />
                            <div className="position active_btn">3</div>
                            <div className="line active_line" />
                            <div className="position active_btn">4</div>
                        </div>

                        <div className="inf_login">
                            <div className="title">Access recovery</div>
                            <div className="subtitle">Password changed successfully!</div>
                        </div>

                        <div className="subtitle pass_alt_success">
                            Your password has been changed successfully! You can now log in with your new password.
                        </div>

                        <div className="subtitle pass_alt" onClick={ () => { setStage(0); setStatusError(false); } }>
                            Return to login
                        </div>
                    </div>
                );
        }        
    }
    
    return (
        <form className="page_content Page_Login" onSubmit={ LoginDash }>
            <div className="bg_img" style={ { backgroundImage: 'url("./assets/bg_login.jpg")' } } />

            <div className="div_logo">
                <Svg_LogoTipo className="logo_tipo" />
                <div className="text">THE REAL ESTATE PLATFORM</div>
            </div>
            
            <div className="div_data_login">
                {
                    stage === 0 ?
                        <>
                            <div className="inf_login">
                                <div className="title">Welcome</div>
                                <div className="subtitle">Please enter your login access</div>
                            </div>
                            <div className="div_inputs">
                                <div className="input">
                                    <Input_Text title="Email" type="email" value={ email } setValue={ setEmail } placeholder="Enter your email" required={ true } />
                                </div>
                                <div className="input">
                                    <Input_Password title="Password" value={ password } setValue={ setPassword } placeholder="Enter your password" required={ true } recover={ true } setStage={ setStage } />
                                </div>
                                {
                                    statusError ?
                                        <div className="subtitle return_error">
                                            { msgError }
                                        </div>
                                    : null
                                }
                                <div className="btn_">
                                    <Btn title="Login Bees" />
                                </div>
                            </div>
                        </>
                    : PositionStage()
                }
            </div>
        </form>
    );
}